import React, { useState } from 'react';
import { ChatLauncher } from './ChatLauncher';
import { ChatWindow } from './ChatWindow';
import { useSocket } from '../../../hooks/useSocket';

export const ChatWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  
  const { messages, isTyping, connectionStatus, sendMessage, resetSession, startSession } = useSocket();

  const handleSendMessage = (text: string) => {
    sendMessage(text);
  };

  const handleClose = () => {
    setIsOpen(false);
    resetSession();
  };

  const handleOpen = () => {
    setIsOpen(true);
    startSession();
  };

  return (
    <>
      <ChatLauncher isOpen={isOpen} onClick={isOpen ? handleClose : handleOpen} />
      
      <ChatWindow 
        isOpen={isOpen} 
        onClose={handleClose}
        messages={messages}
        onSendMessage={handleSendMessage}
        isTyping={isTyping}
        connectionStatus={connectionStatus}
      />
    </>
  );
};